import { useEffect, useState } from "react";
import { isEndpointUnavailable } from "../api/client";

interface RemoteResource<T> {
  data: T | null;
  loading: boolean;
  error: string;
  unsupported: boolean;
  reload: () => void;
}

export function useRemoteResource<T>(loader: () => Promise<T>): RemoteResource<T> {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [unsupported, setUnsupported] = useState(false);
  const [revision, setRevision] = useState(0);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError("");
    setUnsupported(false);
    loader()
      .then((result) => {
        if (active) setData(result);
      })
      .catch((reason: unknown) => {
        if (!active) return;
        if (isEndpointUnavailable(reason)) {
          setUnsupported(true);
          setData(null);
          return;
        }
        setError(reason instanceof Error ? reason.message : "数据加载失败");
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [loader, revision]);

  return {
    data,
    loading,
    error,
    unsupported,
    reload: () => setRevision((value) => value + 1),
  };
}
